<template>
  <div class="flex-grid">
    <Loading :is-progress="isProgress" />
    <Confirm
      :text="deleteText"
      :is-visible="isDelete"
      @onConfirm="onConfirm"
    />
    <div class="col1">
      <div class="main_heading">
        <h3>Manage Custom Templates</h3>
        <a
          class="button_create"
          href="/createcustommailer/"
        >Create Custom Template</a>
      </div>
      <div
        v-if="isPreview"
        class="preview-html"
      >
        <span
          class="close-button"
          @click="closePreview()"
        >X</span>
        <div
          class="html-content"
          v-html="htmlContent"
        />
      </div>
      <v-client-table
        :columns="columns"
        :data="customTemplatesList"
        :options="options"
      >
        <template
          slot="actions"
          slot-scope="props"
        >
          <a
            class="glyphicon glyphicon-eye-open"
            @click="previewTemplate(props.row.key)"
          />
          <a
            :href="`/createcustommailer/?id=${props.row.id}`"
            class="glyphicon glyphicon-edit"
          />
          <a
            class="glyphicon glyphicon-trash"
            @click="deleteConfirm(props.row.id, props.row.key)"
          />
        </template>
      </v-client-table>
    </div>
  </div>
</template>
<script>
import Loading from '@/components/loading.vue';
import Confirm from '@/components/Confirm.vue';

export default {
  name: 'CustomMailerTemplate',
  components: {
    Loading,
    Confirm,
  },
  data() {
    return {
      columns: ['sno', 'name', 'status', 'actions'],
      options: {
        headings: {
          sno: '#',
          name: 'Mailer Name',
          status: 'Status',
          actions: 'Actions',
        },
        sortable: ['status', 'name'],
        filterable: ['status', 'name'],
      },
      customTemplatesList: [],
      isPreview: false,
      isProgress: true,
      isDelete: false,
      currentMailer: '',
      currentMailerKey: '',
      deleteText: 'Are You Sure Want To Delete?',
      htmlContent: '',
      fasciasList: [],
      categoryList: [],
    };
  },
  mounted() {
    const getCustomTemplates = fetch('/api/customTemplates/all', {
      credentials: 'same-origin',
    });
    getCustomTemplates
      .then(data => data.json())
      .then((data) => {
        let customTemplatesArray = [];
        customTemplatesArray = data.map((customTemplate, i) => {
          const obj = {
            sno: i + 1,
            id: `${customTemplate._id}`,
            name: `${customTemplate.mailerName}`,
            status: `${customTemplate.status}`,
            content: `${customTemplate.content}`,
            key: i,
          };
          return obj;
        });
        this.customTemplatesList = customTemplatesArray;
        this.isProgress = false;
      });
  },
  methods: {
    deleteConfirm(id, key) {
      this.currentMailer = id;
      this.currentMailerKey = key;
      this.isDelete = true;
    },
    onConfirm(state) {
      this.isDelete = false;
      if (state === 'yes') {
        this.deletecustomTemplate(this.currentMailer);
      }
    },
    deletecustomTemplate(id) {
      const url = `/api/deletecustomTemplate/${id}`;
      fetch(url, {
        method: 'DELETE',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(res => res.json())
        .catch(error => this.$toasted.error(
          `Something Went Wrong. Please try again - ${error}`,
          { duration: 3000 },
        ))
        .then(response => this.$toasted.success(response.message, { duration: 3000 }))
        .then(
          this.customTemplatesList.splice(
            this.customTemplatesList.findIndex(cusTemp => cusTemp.id === id),
            1,
          ),
        );
    },
    previewTemplate(index) {
      this.isPreview = true;
      this.htmlContent = `${this.customTemplatesList[index].content}`;
    },
    closePreview() {
      this.isPreview = false;
      this.htmlContent = '';
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.preview-html {
  display: block; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}

.close-button {
  right: 15px;
  position: fixed;
  color: white;
  cursor: pointer;
  margin-top: 5%;
  background-color: red;
  padding: 10px 15px;
  border-radius: 25px;
  font-weight: 900;
}

.html-content {
  margin: 5% 0;
}

.flex-grid {
  display: flex;
  justify-content: space-between;
}

.col1 {
  width: 100%;
}
</style>
